import type { QueryClient } from '@tanstack/react-query';

/**
 * Rafraîchit les listes de dossiers après que l'agent a créé un dossier ou repris
 * un dossier existant (`create_case`).
 *
 * WHY pas les conversations : le dossier de la conversation et sa liste arrivent
 * par la trame `conversation_cases` (`conversationCasesBridge.ts`), qui écrit le
 * détail ; le rafraîchir ici le relirait pour rien.
 */
export function invalidateCaseListQueries(
  queryClient: QueryClient,
  cabinetId: string | null,
): void {
  // Convention du dépôt : la clé spécifique ET la clé générale.
  if (cabinetId) {
    void queryClient.invalidateQueries({ queryKey: ['cases', cabinetId] });
  }
  void queryClient.invalidateQueries({ queryKey: ['cases'] });
}
